import { Button, ButtonProps, Tooltip } from '@nextui-org/react';
import { PiFileCsvFill } from 'react-icons/pi';
import Icon from '../base/Icon';

export default function ButtonExportCsv(props: ButtonProps) {
  return (
    <Tooltip content="Export as CSV" placement="bottom">
      <Button {...props}>
        <Icon icon={PiFileCsvFill} className="w-4 h-4" />
      </Button>
    </Tooltip>
  );
}
